module.exports = __webpack_public_path__ + "img/aiyuigon-banner-pc.3e64cab9.svg";